export default __webpack_public_path__ + "static/char-20-216493c197e8823c7140282983250a01.webp";